import type { Polygon } from "geojson";
import { APIError, ImportStatus, PERMISSION } from ".";

export enum CaseCreationType {
  NORMAL = "NORMAL",
  PREDEFINED = "PREDEFINED",
}

export enum CaseCreationStatus {
  PREPARATION = "PREPARATION",
  RETRIEVE_REGION = "RETRIEVE_REGION",
  CREATE_GRID_CONFIGURATIONS = "CREATE_GRID_CONFIGURATIONS",
  CREATE_POI_COLLECTION = "CREATE_POI_COLLECTION",
  CREATE_BASE_SCENARIO = "CREATE_BASE_SCENARIO",
  CREATE_NETWORK = "CREATE_NETWORK",
  CREATE_FLEET = "CREATE_FLEET",
  CREATE_BACKGROUND_METEO = "CREATE_BACKGROUND_METEO",
  CREATE_POINT_SOURCES = "CREATE_POINT_SOURCES",
  FINISHED = "FINISHED",
  FAILED = "FAILED",
}

export enum CaseStatus {
  PREPARING = "PREPARING",
  CREATION_FINISHED = "CREATION_FINISHED",
  CREATION_FAILED = "CREATION_FAILED",
  CALCULATING = "CALCULATING",
  CALCULATION_FINISHED = "CALCULATION_FINISHED",
  CALCULATION_FAILED = "CALCULATION_FAILED",
}

export enum CaseCopyStatus {
  COPYING = "COPYING",
  FINISHED = "FINISHED",
  FAILED = "FAILED",
}

export enum TimefactorType {
  RUSH_HOUR = "RUSH_HOUR",
  DAILY_AVERAGE = "DAILY_AVERAGE",
  YEARLY_TOTAL = "YEARLY_TOTAL",
}

// CaseBase is the overview case result, more details are proviced in Case
export interface CaseBase {
  id: number;
  name: string;
  caseCreationType: CaseCreationType;
  status: CaseStatus;
  creationErrors: APIError[];
  ospmEnabled: boolean;
  runErrors: {
    scenarioId: number;
    scenarioName: string;
    errors: APIError[];
  }[];
  nbScenarios: number;
  dateCreated: Date;
  copyStatus: CaseCopyStatus;
  copyErrors: APIError[];
  permissions: {
    copyScenario: PERMISSION;
    createScenario: PERMISSION;
    delete: PERMISSION;
    poi: PERMISSION;
    update: PERMISSION;
    updateGeneralSettings: PERMISSION;
    updateLineBasedGrid: PERMISSION;
    updatePointBasedGrid: PERMISSION;
    updateRegularGrid: PERMISSION;
  };
}

export interface Case extends CaseBase {
  description: string;
  userSrid: number;
  timefactorType: TimefactorType;
  poiImportErrors: APIError[];
  poiImportStatus: ImportStatus;
  poiImportWarnings: APIError[];
  buffer_frontendSrid: string;
}

export interface CaseShapeUploadResponse {
  polygon_4326: Polygon;
  warningList: string[];
}
